/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_FooterInputs */

const vi_invoice_footer = /** @type {(inputs: Invoice_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung cuối hóa đơn thanh toán`)
};

/**

* @param {Invoice_FooterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_footer = /** @type {((inputs?: Invoice_FooterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_FooterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_footer(inputs)
});